import { render, staticRenderFns } from "./UserPersonalDataSidebar.vue?vue&type=template&id=d42257f2&scoped=true"
import script from "./UserPersonalDataSidebar.vue?vue&type=script&lang=js"
export * from "./UserPersonalDataSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserPersonalDataSidebar.vue?vue&type=style&index=0&id=d42257f2&prod&lang=scss&scoped=true"
import style1 from "./UserPersonalDataSidebar.vue?vue&type=style&index=1&id=d42257f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42257f2",
  null
  
)

export default component.exports